import { Box, CircularProgress, Modal } from "@mui/material";
import { RxCross1 } from "react-icons/rx";
import { useQuery } from "@tanstack/react-query";
import { fetchDetailVoucher } from "../../../../services/purchaseApi";
import moment from "moment";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const toIDR = (val) =>
  val?.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
  });

const ModalVoucherTnc = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen(null);
  };

  const { data: dataDetail, isFetching } = useQuery({
    queryKey: ["detail_voucher", open],
    queryFn: () => fetchDetailVoucher(open),
    enabled: open !== null,
  });

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            maxWidth: "75%",
            overflowY: "hidden",
            overflowX: "wrap",
            maxHeight: "80vh",
            padding: 0,
          }}
          className="text-left text-[12px] w-3/4 lg:w-2/3 h-fit text-[#2C3E5D]"
        >
          <div className="flex justify-between items-center px-8 py-4">
            <p className="text-[18px]">Syarat & Ketentuan</p>
            <RxCross1
              className="cursor-pointer hover:text-red-500"
              onClick={handleClose}
            />
          </div>

          <div className="px-8 pb-4 overflow-y-auto overflow-x-hidden max-h-[60vh]">
            {dataDetail && !isFetching ? (
              <div>
                <p>Voucher {dataDetail.voucher_name}</p>
                <p>
                  Berlaku hingga{" "}
                  {moment(dataDetail.voucher_expired).format("DD MMMM YYYY")}
                </p>
                <p className="mb-2">
                  Minimum transaksi {toIDR(dataDetail.minimum_purchase)}
                </p>

                {dataDetail.terms ? (
                  <ol className="">
                    {dataDetail.terms.map((term, i) => {
                      return (
                        <li className=" list-item list-inside">
                          {i + 1}. {term}
                        </li>
                      );
                    })}
                  </ol>
                ) : null}
                <p>{dataDetail.voucher_information}</p>
              </div>
            ) : isFetching ? (
              <CircularProgress size={20} />
            ) : (
              <p>Tidak ada syarat dan ketentuan</p>
            )}
          </div>

          <div className="px-8 pb-4 flex justify-end">
            <button
              type="button"
              className="text-white bg-[#94C679] hover:bg-gray-300 rounded-md w-fit py-2 px-4 disabled:bg-gray-300"
              onClick={handleClose}
            >
              Tutup
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ModalVoucherTnc;
